import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API_BASE } from './wizard/constants';
import { LEGAL_DOCUMENTS } from './wizard/legalDocument';

export default function PublicLegalDocument() {
  const { tenantSlug, kind } = useParams();
  const spec = LEGAL_DOCUMENTS[kind];
  const [state, setState] = useState({ status: 'loading', school: '', text: '', url: '' });

  useEffect(() => {
    if (!spec) {
      setState({ status: 'missing', school: '', text: '', url: '' });
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(
          `${API_BASE}/public/registrations/${encodeURIComponent(tenantSlug)}/config`,
        );
        if (cancelled) return;
        setState({
          status: 'ok',
          school: r.data?.tenant_name || '',
          text: String(r.data?.[spec.textKey] || '').trim(),
          url: String(r.data?.[spec.urlKey] || '').trim(),
        });
      } catch (_e) {
        if (!cancelled) setState({ status: 'error', school: '', text: '', url: '' });
      }
    })();
    return () => { cancelled = true; };
  }, [tenantSlug, kind, spec]);

  const title = spec?.title || 'Dokument';
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <main className="max-w-3xl mx-auto px-4 py-10" data-testid="public-legal-document">
        <h1 className="text-2xl font-semibold">{title}</h1>
        {state.school && <p className="mt-1 text-slate-500">{state.school}</p>}
        {state.status === 'loading' && (
          <p className="mt-8 flex items-center gap-2 text-slate-600">
            <Loader2 className="h-4 w-4 animate-spin" /> Dokument wird geladen …
          </p>
        )}
        {state.status === 'missing' && (
          <p className="mt-8 text-slate-600">Dieses Dokument gibt es hier nicht.</p>
        )}
        {state.status === 'error' && (
          <p className="mt-8 text-slate-600">Das Dokument konnte nicht geladen werden.</p>
        )}
        {state.status === 'ok' && state.url && (
          <p className="mt-6">
            <a href={state.url} className="text-brand-red underline" data-testid="public-legal-document-url">
              {title} auf der Webseite der Schule öffnen
            </a>
          </p>
        )}
        {state.status === 'ok' && state.text && (
          <article className="mt-6 whitespace-pre-line text-sm leading-relaxed" data-testid="public-legal-document-text">
            {state.text}
          </article>
        )}
        {state.status === 'ok' && !state.text && !state.url && (
          <p className="mt-8 text-slate-600" data-testid="public-legal-document-empty">
            Für diese Schule ist noch kein Dokument hinterlegt.
          </p>
        )}
      </main>
    </div>
  );
}
